// extracted by mini-css-extract-plugin
export default {"wrapper":"MapPOIS_wrapper__Ilwcw","map_title_style":"MapPOIS_map_title_style__ivHg0"};